import uploadDesignImage from "assets/images/dtf/dtf-bot-upload-design.png";
import printShipImage from "assets/images/dtf/dtf-bot-print-ship.png";
import heatPressImage from "assets/images/dtf/dtf-bot-heat-press.png";

const WHAT_IS_DTF = {
  title: "What is DTF?",
  description:
    "Direct to Film (DTF) Transfers are incredibly vivid and high quality transfers that can be applied to almost any Product, Material, and Color with just a heat press, cricut, or iron! Millions trust DTF Transfers for their events, team, merch, crafts, gifts, and more! DTF saves you money, time, and allows you to customize products the way you want.",
};

const DTF_PROCESS = {
  title: "The Shirtly DTF Process",
  subtitle: "Faster. Simpler. Satisfaction Guaranteed.",
  steps: [
    {
      title: "Upload Your Design & Order Online",
      description:
        "From simple graphics to high-detail artwork, upload any design with unlimited colors. We convert it into a high-quality DTF transfer, ready to press.",
      image: uploadDesignImage,
      alt: "Upload Your Design & Order Online",
      animation: "float",
    },
    {
      title: "Print & Shipped in 24–48 Hours",
      description:
        "We produce your transfer using our proprietary DTF process for sharp detail, vibrant color, and consistent, professional-grade results.",
      image: printShipImage,
      alt: "Print & Shipped in 24–48 Hours",
      animation: "run",
    },
    {
      title: "Heat Press or Iron when Ready",
      description:
        "Press at 310°F / 155°C with medium pressure for 12–15 seconds. Repress for 5 seconds for maximum durability. Unused transfers store long-term without loss of quality.",
      image: heatPressImage,
      alt: "Heat Press or Iron when Ready",
      animation: "press",
    },
  ],
};

export { WHAT_IS_DTF, DTF_PROCESS };
